import { render, staticRenderFns } from "./ProductsGrid.vue?vue&type=template&id=2cf13540&scoped=true"
import script from "./ProductsGrid.vue?vue&type=script&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductsGrid.vue?vue&type=style&index=0&id=2cf13540&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf13540",
  null
  
)

export default component.exports